var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFacebook(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 45,
    viewBox: "0 0 45 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M40.6055 22.9146C40.6055 12.6587 32.3421 4.34473 22.1485 4.34473C11.9549 4.34473 3.69141 12.6587 3.69141 22.9146C3.69141 32.1832 10.4409 39.8657 19.2646 41.2589V28.2824H14.5782V22.9146H19.2646V18.8234C19.2646 14.1693 22.0202 11.5986 26.236 11.5986C28.2555 11.5986 30.3676 11.9613 30.3676 11.9613V16.5312H28.0403C25.7476 16.5312 25.0324 17.9628 25.0324 19.4313V22.9146H30.1513L29.3331 28.2824H25.0324V41.2589C33.8562 39.8657 40.6055 32.1835 40.6055 22.9146Z",
    fill: "#221511"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebook);
export default __webpack_public_path__ + "static/media/Facebook.8cf65b400c4cdf7c1d9e37f09ceff74e.svg";
export { ForwardRef as ReactComponent };